<div class="form-group">
  <div class="alert alert-success" role="alert">
    <h4 class="alert-heading">Elije una Imagen del producto!!!</h4>
    <div class="container">
      <input
        type="file"
        name="img"
        id="img"
        accept="image/png, image/jpeg, image/gif"
        class="btn btn-primary"
        (change)="onChange1($event)"
        #fileUpload
        hidden
      />
      <div class="input-group">
        <input
          type="text"
          [(ngModel)]="name"
          class="form-control"
          aria-label="Dollar amount (with dot and two decimal places)"
        />
        <span class="input-group-text" (click)="fileUpload.click()">
          <i class="fas fa-file-image" aria-hidden="true"></i>
        </span>
      </div>

      <div id="visorArchivo1" *ngIf="previsualizacion">
        <img [src]="previsualizacion" width="auto" height="200px" />
        <!-- despliegue de archivo -->
      </div>
      <div id="visorArchivo1" *ngIf="!previsualizacion">
        <img [src]="view" width="auto" height="200px" />
        <!-- despliegue de archivo -->
      </div>

      <hr />
    </div>
  </div>
</div>
